import {NgModule} from '@angular/core';
import {DragNDropDirective} from './drag-n-drop.directive';
import {DragStartStopDirective} from './drag-start-stop.directive';

@NgModule({
  declarations: [DragNDropDirective, DragStartStopDirective],
  exports: [DragStartStopDirective, DragNDropDirective],
})
export class DragNDropDirectiveModule {}
